import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const ImprintPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-lg shadow-lg p-8 md:p-12"
        >
          <h1 className="text-4xl font-bold text-gray-800 mb-8 border-b pb-4">
            {t('imprint.title')}
          </h1>

          <div className="space-y-8 text-gray-700">
            {/* Company Info */}
            <section>
              <h2 className="text-2xl font-semibold text-primary-green mb-4">
                {t('imprint.companyInfo')}
              </h2>
              <div className="bg-gray-50 p-6 rounded-lg border border-gray-100">
                <p className="font-bold text-lg mb-1">Svansele Grönt</p>
                <p>Svansele 2</p>
                <p>936 93 Boliden</p>
                <p>Sverige</p>
              </div>
            </section>

            {/* Contact */}
            <section>
              <h2 className="text-2xl font-semibold text-primary-green mb-4">
                {t('imprint.contact')}
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-center">
                  <span className="font-semibold w-24">{t('imprint.phone')}:</span>
                  <a href="tel:+46706379314" className="text-accent-green hover:underline">
                    +46 (0)70 637 93 14
                  </a>
                </div>
                <div className="flex items-center">
                  <span className="font-semibold w-24">{t('imprint.email')}:</span>
                  <a href="mailto:svanselemajeri@norsjo.nu" className="text-accent-green hover:underline">
                    svanselemajeri@norsjo.nu
                  </a>
                </div>
                <div className="flex items-center">
                  <span className="font-semibold w-24">{t('imprint.website')}:</span>
                  <a href="https://svanselegront.se" className="text-accent-green hover:underline">
                    www.svanselegront.se
                  </a>
                </div>
              </div>
            </section>

            {/* Legal Rep */}
            <section>
              <h2 className="text-2xl font-semibold text-primary-green mb-4">
                {t('imprint.legalRep')}
              </h2>
              <p className="mb-2">{t('imprint.legalRepText')}</p>
              <p className="font-bold">Olof Berglund</p>
            </section>

            {/* Disclaimer */}
            <section>
              <h2 className="text-2xl font-semibold text-primary-green mb-4">
                {t('imprint.disclaimer')}
              </h2>
              
              <div className="mb-4">
                <h3 className="text-lg font-semibold mb-2">{t('imprint.contentLiability')}</h3>
                <p>{t('imprint.contentLiabilityText')}</p>
              </div>

              <div>
                <h3 className="text-lg font-semibold mb-2">{t('imprint.linkLiability')}</h3>
                <p>{t('imprint.linkLiabilityText')}</p>
              </div>
            </section>

            {/* Copyright */}
            <section>
              <h2 className="text-2xl font-semibold text-primary-green mb-4">
                {t('imprint.copyright')}
              </h2>
              <p>{t('imprint.copyrightText')}</p>
            </section>

            {/* Image Credits */}
            <section>
              <h2 className="text-2xl font-semibold text-primary-green mb-4">
                {t('imprint.imageCredits')}
              </h2>
              <p className="mb-2">{t('imprint.imageCreditsText')}</p>
              <ul className="list-disc pl-5">
                {(t('imprint.imageSourcesList', { returnObjects: true }) || []).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ImprintPage;